var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t('download-annotations')))]),_c('button',{staticClass:"button is-small is-fullwidth",on:{"click":function($event){return _vm.download()}}},[_vm._m(0),_c('span',[_vm._v(_vm._s(_vm.$t('button-download')))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fas fa-download"})])
}]

export { render, staticRenderFns }